import {
  FETCH_CORRECTIBLE_BEGIN,
  FETCH_CORRECTIBLE_SUCCESS,
  FETCH_CORRECTIBLE_FAILURE
} from "../actions/types";

const initialState = {
  loading: false,
  error: "",
  correctible: []
};

let fetchCount = 0;

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CORRECTIBLE_BEGIN:
      fetchCount++;
      return {
        ...state,
        loading: true,
        error: "",
        correctible: []
      };
    case FETCH_CORRECTIBLE_SUCCESS:
      fetchCount--;
      if (fetchCount < 1) {
        return {
          ...state,
          loading: false,
          correctible: action.payload
        };
      }
      return state;
    case FETCH_CORRECTIBLE_FAILURE:
      fetchCount--;
      if (fetchCount < 1) {
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      }
      return state;

    default:
      return state;
  }
};
